import Compressor from 'compressorjs';
import { getPrimaryFunctionAppRoot } from './functionAppRoot';

export async function uploadBlobFile(
  file: File,
  idToken: string,
  options?: { maxWidth?: number; maxHeight?: number; quality?: number }
): Promise<{ id: string; name: string }> {
  const maxWidth = options?.maxWidth ?? 1024;
  const maxHeight = options?.maxHeight ?? 768;
  const quality = options?.quality ?? 0.8;

  const uploadBytes = async (blob: Blob, fileName: string, contentType?: string) => {
    const id = crypto.randomUUID();
    const endpoint = `${getPrimaryFunctionAppRoot()}/AddBlob`;
    const url = `${endpoint}?id=${encodeURIComponent(id)}&it=${idToken}`;
    const response = await fetch(url, {
      method: 'POST',
      body: blob,
      headers: {
        'Content-Type': contentType || blob.type || file.type || 'application/octet-stream',
        'X-Filename': fileName
      }
    });
    const responseText = (await response.text()).trim();
    if (!response.ok || responseText.length > 0) {
      throw new Error(responseText || 'Upload failed');
    }
    return { id, name: fileName };
  };

  if (file.type.startsWith('image/')) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-new
      new Compressor(file, {
        maxWidth,
        maxHeight,
        quality,
        success(result) {
          uploadBytes(result, file.name, 'image/jpeg').then(resolve).catch(reject);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  return uploadBytes(file, file.name);
}
